import { isImageFile } from '@components/ArtBoard/TabAttachments/components/AttachmentContent/components/FileContent/helper'
import { StorageActions } from '@store/reducers/manager/storage'
import { UploadResultActions } from '@store/uploadResultSaga/actions'
import { all, delay, put, takeLatest } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import {
  clearError,
  showDefaultError,
  showError,
} from '@/hooks/useAttachFile/actions'

const isStorageLimitMessage = (message?: string) =>
  message?.includes('Storage limit exceeded')

function* error({ payload }: ReturnType<typeof UploadResultActions.error>) {
  // todo: support exact error from upload api
  // @ts-expect-error
  const message = payload.response?.data?.errors?.file

  const gtmEvent = isStorageLimitMessage(message)
    ? GtmTriggerName.UPLOAD_FILE_ATTACHMENT_SIZE_ERROR
    : GtmTriggerName.UPLOAD_FILE_ATTACHMENT_ERROR

  const errorAction = message ? showError(message) : showDefaultError()

  sendGtmEvent(gtmEvent)
  yield put(errorAction)

  yield delay(300)
  yield put(clearError())
}

function* success({
  payload: item,
}: ReturnType<typeof UploadResultActions.success>) {
  const gtmEvent = isImageFile(item.filename)
    ? GtmTriggerName.UPLOAD_IMAGE_ATTACHMENT_SUCCESS
    : GtmTriggerName.UPLOAD_FILE_ATTACHMENT_SUCCESS

  // todo: add special saga for gtm events
  sendGtmEvent(gtmEvent)

  yield put(StorageActions.appendAttachments([item]))
}

export function* uploadResultSaga() {
  yield all([
    takeLatest(UploadResultActions.success.type, success),
    takeLatest(UploadResultActions.error.type, error),
  ])
}
